import { FC } from 'react'
import { CheckIcon, RemoveIcon } from 'components/svg'

interface Props {
  value: boolean
}

const Boolean: FC<Props> = ({ value }) =>
  value ? <CheckIcon /> : <RemoveIcon />

export default Boolean
